import { i as o } from "../../../floating-ui.react-DxYXKqW-.js";
import { useEffect as r } from "react";
import { usePopover as a } from "./usePopover.js";
const x = (i, e = null) => {
  const t = a(), { ref: c, index: u } = o({ label: i }), s = (t == null ? void 0 : t.setVirtualFocus) && u === (t == null ? void 0 : t.activeIndex), m = s ? 0 : -1;
  return r(() => {
    var n;
    s && ((n = t == null ? void 0 : t.setVirtualFocus) == null || n.call(t, e));
  }, [s, t, e]), {
    isActiveInPopover: s,
    ref: c,
    tabIndex: t ? m : void 0
  };
};
export {
  x as usePopoverItem
};
